<div id="menu3" class="tab-pane teamSummTable" [intouchloader2]="isLoader">
    <div class="attendCal customAttendCal">
       <div class="dropdown customDropdown"> <a href="#" class="dropdown-toggle" data-toggle="dropdown"><span><i class="material-icons">today</i>{{selectedYearStr}}</span></a>
        <div class="dropdown-menu">
            <ng-container *ngFor="let year of years">
                <a class="dropdown-item" href="#" (click)="changeYear(year)"  >{{year}}</a>
            </ng-container>
            <!-- <a class="dropdown-item" href="#" >2021</a>
            <a class="dropdown-item" href="#" >2022</a>
            <a class="dropdown-item" href="#" >2023</a> -->
        </div>
    </div>
        <ul class="leaveStatusList scroll-touch">
            <li *ngFor="let attendanceType of attendanceTypeList">
                <!-- <ng-container *ngIf="attendanceType.isApplicable"> -->
                    <span class="colorDots leaveDot01" 
                    [ngStyle]="{'background-color': attendanceType.colorCode}"></span>
                {{attendanceType.name}}
                <!-- </ng-container> -->
              
            </li>
            <!-- <li><span class="colorDots leaveDot02"></span>Half Day</li>
            <li><span class="colorDots leaveDot03"></span>Festival Flexi</li>
            <li><span class="colorDots leaveDot04"></span>Others</li> -->
        </ul>
    </div>
    <!-- <ul class="caldBtmIcon">
        <li><a href="#" class="fullscreenToggle"><i class="material-icons">fullscreen</i></a></li>
    </ul> -->
    <div class="attendTable">
        <div class="reportpanel">
            <div class="table-responsive">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th scope="col" class="columCenter">
                                <p>{{totalTeamMembers}}<span class="bottomText">Team Member</span></p>
                                <div class="emFilterDiv">
                                    <a href="#" class="emFilterIcon dropdown-toggle" data-toggle="dropdown"><i class="material-icons">group</i></a>
                               
                                <div class="dropdown-menu">
                                    <div class="inputSec">
                                        <a href="#" class="searchIcon"><i class="material-icons">search</i></a>
                                        <input class="inputfield" type="text" value="" placeholder="Search for users" [(ngModel)]="fieldUserSearch">
                                    </div>
                                    <ul class="membersList">
                                        <ng-container *ngIf="userLeaveSummaries | customSearchPipe:fieldUserSearch:filteredData:searchableHeaderKeys as list">
                                            <li *ngFor="let user of list"  (change)="userfilter(user);">
                                                <label>
                                                    <input type="checkbox" name="" [(ngModel)]="user.checked" class="checkbox"> 
                                                    
                                                    <div *ngIf="user.userInfo && user.userInfo.profileDocId" class="peopleText pic">
                                                        <img  src="{{imageBaseUrl}}{{user.userInfo.profileDocId}}" alt="" class="mCS_img_loaded">
                                                    
                                                    </div>
                                                    <div  class="peopleText {{getShortNameColor(user.userInfo)}}" *ngIf=" !user.userInfo || !user.userInfo.profileDocId">
                                                    {{getShortName(user.userInfo)}}</div>
                                                    <!-- <div class="peopleText pic" *ngIf="emp.userInfo.name">
                                                        <img src="https://workmate.mapmyindia.com/app/images/logo_1613718638696_5.PNG">
                                                    </div> -->
                                                    {{user.userInfo && user.userInfo.name ? user.userInfo.name: ''}}
                                                </label>
                                            </li>
                                
                                        </ng-container>
                                    </ul>
                                </div>
                            </div>
                            </th>
                            <th scope="col" *ngFor="let month of listOfMonths; let i = index">
                                <p>{{month}}</p>
                            </th>
                           
                        </tr>
                    </thead>
                    <tbody *ngIf="userLeaveSummaries.length==0  &&  !isLoader  ">
                        <tr>
                            <div class="nodataDiv" >
                                <span class="nodataimg"><img src="assets/img/nodataImg.png" alt=""></span>
                                <p>No Leaves Marked</p>
                               
                            </div>
                        </tr>
                    </tbody>
                    <tbody>
                        <ng-container *ngIf="userLeaveSummaries |customFieldsFilter: customFieldFilterObject as filteredList">
                            <cdk-virtual-scroll-viewport itemSize="8" class="example-viewport">
                                <tr *cdkVirtualFor="let user of filteredList ; let j = index">
                            <!-- <tr *ngFor="let user of filteredList ; let j = index"> -->
                            <td>
                                <div class="elPicDiv">
                                    <div *ngIf="user.userInfo && user.userInfo.profileDocId" class="peopleText pic">
                                        <img  src="{{imageBaseUrl}}{{user.userInfo.profileDocId}}" alt="" class="mCS_img_loaded">
                                    
                                    </div>

                                    <div class="peopleText {{getShortNameColor(user.userInfo)}}" *ngIf=" !user.userInfo || !user.userInfo.profileDocId" >
                                    
                                          {{getShortName(user.userInfo)}}
                                       
                                    </div>
                                    <div class="elPicDivCont"><span>{{user.userInfo && user.userInfo.name ? user.userInfo.name: ''}}</span>
                                        <small *ngIf="user.leaveInfo">Total {{user.leaveInfo.totalDays ? user.leaveInfo.totalDays: 0}} days</small>
                                    </div>
                                </div>
                            </td>
                           
                            <td *ngFor="let month of listOfMonths; let i = index">
                                <ng-container *ngIf="user.leaveInfo && user.leaveInfo.monthlyLeaves && user.leaveInfo.monthlyLeaves[i+1]">

                                    <!-- *ngFor="let laeves of monthlyLeaves" -->
                                <ng-container *ngIf="user.leaveInfo.monthlyLeaves[i+1].leaveByType as leaveByType">
                                    <!-- <div class="leaveDotsStatus tip2"  attr.data-tip="tip-third{{i}}{{j}}" attr.data-placement="right" (mouseenter)="enableTooltip($event)" tooltip> -->
                                    <div class="leaveDotsStatus tip2"  attr.data-tip="tip-third{{i}}{{j}}" data-placement="right">
                                        <ng-container *ngFor="let leave of getLeaveListForMonth(leaveByType)">
                                            <span class="singleDot " *ngIf="leave.count && leave.count <=1 " [ngStyle]="{'background-color': getLeaveColor(leave)}">
                                                <!-- firstHalf {{leaveByType |json}} -->
                                                
                                            </span>
                                            <span class="multipleDot" [ngStyle]="{'border-color': getLeaveColor(leave)}" *ngIf="leave.count && leave.count>1">
                                                <span [ngStyle]="{'background-color': getLeaveColor(leave)}"></span>
                                                <span [ngStyle]="{'background-color': getLeaveColor(leave)}"></span>
                                            </span>
                                        </ng-container>
                                    </div>
                                    <div id="tip-third{{i}}{{j}}" class="tip-content hidden" style="display: none;">
                                        <div class="tooltipSec">
                                            <ng-container *ngFor="let leaveType of attendanceTypeList">
                                                <h3 *ngIf="leaveByType[leaveType.id] as leaveByTypeList">
                                                    <span  class="aClass" [ngStyle]="{'color': leaveType.colorCode}">{{leaveType.name}}</span>
                                                    <ng-container *ngFor="let leaveObj of leaveByTypeList">
                                                        <span *ngIf="leaveObj.fromTimestamp && leaveObj.toTimestamp && leaveObj.count==1" [ngStyle]="{'color' : attendanceStatusMap[leaveObj.status].colorClass}">
                                                           {{leaveObj.fromTimestamp * 1000 |date: 'dd MMM yyyy'}}<br>
                                                        </span>
                                                        <span *ngIf="leaveObj.fromTimestamp && leaveObj.toTimestamp && leaveObj.count>1" [ngStyle]="{'color' : attendanceStatusMap[leaveObj.status].colorClass}">
                                                            {{leaveObj.fromTimestamp * 1000 |date: 'dd MMM yyyy'}} - {{leaveObj.toTimestamp * 1000 |date:
                                                            'dd MMM yyyy'}}<br>
                                                        </span>
                                    
                                                    </ng-container>
                                                </h3>
                                            </ng-container>
                                            <!-- <h3><span class="leaveDot04">Other</span>13 Jan 2021 - 17 Jan 2021</h3>                                    -->
                                    
                                        </div>
                                    </div>
                                    <!-- <div id="tip-third{{i}}{{j}}" class="tip-content hidden" style="display: none;">
                                        <div class="tooltipSec">
                                            <ng-container *ngFor="let leaveType of attendanceTypeList">
                                                <h3 *ngIf="leaveByType[leaveType.id] as leaveByTypeList">
                                                    <span class="leaveDot02">{{leaveType.name}}</span>
                                                    <span *ngFor="let leaveObj of leaveByTypeList">
                                                        <span *ngIf="leaveObj.fromTimestamp && leaveObj.toTimestamp && leaveObj.count==1">
                                                            {{leaveObj.fromTimestamp * 1000 |date: 'dd MMM yyyy'}}<br>
                                                        </span>
                                                        <span *ngIf="leaveObj.fromTimestamp && leaveObj.toTimestamp && leaveObj.count>1">
                                                            {{leaveObj.fromTimestamp * 1000 |date: 'dd MMM yyyy'}} - {{leaveObj.toTimestamp * 1000 |date: 'dd MMM yyyy'}}<br>
                                                        </span>
                                                     
                                                    </span>
                                                </h3>
                                               
                                            </ng-container>
                                           
                                        </div>
                                    </div> -->
                                </ng-container>
                                    <p class="greyText" *ngIf="user.leaveInfo.monthlyLeaves[i+1].totalDays"> {{user.leaveInfo.monthlyLeaves[i+1].totalDays}} days</p>
                                </ng-container>
                            </td>
                          
                        </tr>
                            </cdk-virtual-scroll-viewport>
                        </ng-container>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>